export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-[#1a1a2e] via-[#2d1b4e] to-[#3a3a3a]">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      {/* Abstract Geometric Shape */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[45%] h-[70%] bg-gradient-to-br from-cyan-400/30 to-blue-500/20 rounded-l-[100px] blur-3xl"></div>
      
      <div className="relative w-full px-20 py-32">
        <div className="max-w-[55%]">
          <h2 className="text-[80px] font-extrabold text-white leading-[1.1] mb-8" style={{ fontFamily: 'Inter, sans-serif', textShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
            Modern iOS Applications<br />
            <span className="text-cyan-400">For Enhanced Security</span>
          </h2>
          <p className="text-lg font-light text-gray-300 leading-relaxed max-w-[500px]">
            LILA SH.P.K. is a team of experts developing modern applications for the iOS platform. Our products, such as <strong>VPN</strong> and <strong>Cleaner</strong>, are designed to enhance user experience and improve the security of mobile devices.
          </p>
        </div>
      </div>
    </section>
  );
}